import React from 'react';
import { Input } from 'reactstrap';

export function OptionalProtocolNumberPrefix({ onPrefixChange, data }) {
  return (
    <div style={{ maxWidth: 120 }}>
      <Input
        type="text"
        name="protocolNumberPrefix"
        id="protocolNumberPrefix"
        value={data || ''}
        onChange={(e) => onPrefixChange(e.target.value)}
        maxLength={6}
        minLength={2}
        style={{ width: '100%' }}
        pattern=".{2,6}"
        title="Deve ter entre 2 e 6 caracteres"
      />
    </div>
  );
}
